import CountryFlag from './CountryFlag';

type Props = {
  countryCode: string;
};
const CountryCurrent: React.FC<Props> = ({ countryCode }) => {
  return (
    <div className="inline-flex items-center justify-center rounded-full bg-primary-green px-4 py-3 text-[18px]/[22.68px] font-semibold text-white">
      <CountryFlag countryCode={countryCode} />
    </div>
  );
};
export default CountryCurrent;
